import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { ReactElement } from "react";
import NotifsIcon from "../../../../media/images/icons/notification-bing";
import NavBackButton from "../../../components/NavBackButton";
import { useNavigate } from "react-router-dom";

interface Props {
  hasScroll: boolean;
  title: ReactElement;
}

export default function MobileHeader({ hasScroll, title }: Props) {
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        zIndex: 50,
        transition: "box-shadow 500ms",
        boxShadow: hasScroll ? "0px 4px 8px 3px rgba(0,0,0,0.1)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "12px",
        paddingX: "16px",
        backgroundColor: hasScroll ? "#F5F5F5" : "",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavBackButton />
        {title}
      </Box>

      <Button
        onClick={() => navigate("/notifications")}
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          minWidth: "0px !important",
          //   gap: "8px",
          borderColor: `${theme.palette.secondary.main} !important`,
          backgroundColor: `${theme.palette.secondary.light} !important`,
          "& .MuiTouchRipple-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
          "& .MuiButtonBase-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
            minWidth: "0px !important",
          },
          "& .MuiButton-root": {
            minWidth: "0px !important",
          },
        }}
      >
        <NotifsIcon color={theme.palette.secondary.dark} />
      </Button>
    </Box>
  );
}
